import React from 'react';
import { Card, Typography, Space, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { appDesign } from '../theme/appDesign';

const { Title, Paragraph, Text } = Typography;

/**
 * Content mirrors docs/FAQ.md (SDD-friendly single source of truth for copy).
 */
export const FaqPage: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 16px',
        backgroundColor: appDesign.pageBg,
        minHeight: '80vh',
      }}
    >
      <Card style={{ width: '100%', maxWidth: 980, borderRadius: appDesign.radiusMd }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Title level={2} style={{ marginBottom: 0, color: appDesign.text }}>
            FAQ — Compass Mom
          </Title>
          <Text type="secondary">
            Кратко по ролям. Поддержка: info@compass-mom.ru · Telegram @compass_mom
          </Text>

          <Title level={4}>Пациент</Title>
          <Paragraph>
            <ul>
              <li>
                <Text strong>Регистрация:</Text> email, пароль, подтверждение письма.
              </li>
              <li>
                <Text strong>Дневники:</Text> раздел «Дневники» — глюкоза, питание, вес, шевеления,
                симптомы, анализы и визиты.
              </li>
              <li>
                <Text strong>Привязка врача:</Text> в профиле по DR-ID / QR; после принятия откроется
                чат.
              </li>
              <li>
                <Text strong>Файлы:</Text> фото и документы дневников доступны вам и связанному врачу.
              </li>
            </ul>
          </Paragraph>

          <Divider />

          <Title level={4}>Врач</Title>
          <Paragraph>
            <ul>
              <li>
                <Text strong>DR-ID и QR:</Text> в профиле врача.
              </li>
              <li>
                <Text strong>Заявки:</Text> входящие на дашборде — принять или отклонить.
              </li>
              <li>
                <Text strong>Чат и дневники:</Text> после привязки в «Чатах» и карточке пациентки.
              </li>
            </ul>
          </Paragraph>

          <Divider />

          <Title level={4}>Админ</Title>
          <Paragraph>
            <ul>
              <li>Клиники — создание / редактирование / удаление с подтверждением.</li>
              <li>Пользователи — создание, сброс пароля, назначение врача.</li>
              <li>Чат поддержки — обращения пациенток и врачей.</li>
            </ul>
          </Paragraph>

          <Divider />

          <Title level={4}>Безопасность и данные (ФЗ-152)</Title>
          <Paragraph>
            Данные обрабатываются для сервиса мониторинга беременности. Доступ по ролям. HTTPS,
            bcrypt-хэши паролей, проверка типа и размера загрузок. Подробнее —{' '}
            <Link to="/privacy-policy">политика конфиденциальности</Link>.
          </Paragraph>

          <Divider />

          <Title level={4}>Техподдержка</Title>
          <Paragraph>
            Email:{' '}
            <a href="mailto:info@compass-mom.ru">info@compass-mom.ru</a>
            <br />
            Telegram:{' '}
            <a href="https://t.me/compass_mom" target="_blank" rel="noopener noreferrer">
              @compass_mom
            </a>
            <br />
            Укажите роль и email аккаунта.
          </Paragraph>
        </Space>
      </Card>
    </div>
  );
};
